/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
import Swiper from 'swiper';
import {
    Navigation, Keyboard, A11y,
} from 'swiper/modules';

const siteLanguage = document.querySelector('html').getAttribute('lang');
const translations = {
    en: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        slideLabelMessage: '{{index}} of {{slidesLength}}',
    },
    fr: {
        prevSlideMessage: 'Diapositive précédente',
        nextSlideMessage: 'Diapositive suivante',
        paginationBulletMessage: 'Aller à la diapositive {{index}}',
        slideLabelMessage: '{{index}} sur {{slidesLength}}',
    },
};

const resourceNavSlider = document.querySelector('.resource-nav-slider-js');

if (resourceNavSlider) {
    const slidesArray = [...resourceNavSlider.querySelectorAll('.swiper-slide[data-slideid]')];
    if (slidesArray.length > 0) {
        const resource = document.querySelector('.resource-single');
        const currentNid = resource.dataset.currentnid;
        const matchingSlide = slidesArray.find((slide) => slide.dataset.slideid === currentNid);
        const matchingSlideIndex = slidesArray.indexOf(matchingSlide);

        matchingSlide.querySelector('.resource-nav-slide').classList.add('current-resource');

        const resourceNavSliderSwiper = new Swiper(resourceNavSlider.querySelector('.swiper'), {
            modules: [Navigation, A11y, Keyboard],
            a11y: {
                enabled: true,
                prevSlideMessage: `${translations[siteLanguage].prevSlideMessage}`,
                nextSlideMessage: `${translations[siteLanguage].nextSlideMessage}`,
                paginationBulletMessage: `${translations[siteLanguage].paginationBulletMessage}`,
                slideLabelMessage: `${translations[siteLanguage].slideLabelMessage}`,
            },
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: resourceNavSlider.querySelector('.slider-button-next'),
                prevEl: resourceNavSlider.querySelector('.slider-button-prev'),
            },
            direction: 'horizontal',
            initialSlide: matchingSlideIndex,
            slidesPerView: 1.4,
            spaceBetween: 16,
            watchSlidesProgress: true,
            breakpoints: {
                1200: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                },
            },
        });
    } else {
        resourceNavSlider.classList.add('hidden');
    }
}
